import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Box, Tabs, Tab, Typography, Button, Divider } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from '../AuthContext';
import { CDN } from '../api';

const TABS = [
  { label: 'Homes', path: '/dashboard' },
  { label: 'Edit Home', path: '/dashboard/settings' },
];

function AdminLayout({ children }) {
  const { logout } = useAuth();
  const location = useLocation();

  const activeTab = TABS.findIndex(t =>
    t.path === '/dashboard'
      ? location.pathname === '/dashboard' || location.pathname.startsWith('/dashboard/house')
      : location.pathname.startsWith(t.path)
  );

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#0d0d0d' }}>
      {/* Top bar */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: { xs: 2, sm: 4 },
          py: 1.5,
          backgroundColor: '#111',
          borderBottom: '1px solid #222',
        }}
      >
        <Box display="flex" alignItems="center" gap={2}>
          <img
            src={`${CDN}/site/logo.PNG`}
            alt="Logo"
            style={{ height: 36, objectFit: 'contain' }}
          />
          <Typography
            variant="subtitle1"
            fontWeight={600}
            sx={{ color: '#f0f0f0', letterSpacing: '0.02em' }}
          >
            Emerich Custom Build
          </Typography>
        </Box>
        <Button
          onClick={logout}
          startIcon={<LogoutIcon />}
          size="small"
          sx={{ color: '#888', '&:hover': { color: '#f0f0f0' } }}
        >
          Logout
        </Button>
      </Box>

      {/* Tab bar */}
      <Box sx={{ backgroundColor: '#111', borderBottom: '1px solid #222', px: { xs: 2, sm: 4 } }}>
        <Tabs
          value={activeTab === -1 ? 0 : activeTab}
          TabIndicatorProps={{ style: { backgroundColor: '#FFA13C' } }}
          sx={{ minHeight: 44 }}
        >
          {TABS.map((tab, i) => (
            <Tab
              key={tab.path}
              label={tab.label}
              component={Link}
              to={tab.path}
              sx={{
                minHeight: 44,
                fontSize: 13,
                fontWeight: 500,
                color: '#888',
                '&.Mui-selected': { color: '#FFA13C' },
              }}
            />
          ))}
        </Tabs>
      </Box>

      {/* Page content */}
      <Box sx={{ px: { xs: 2, sm: 4 }, py: 4, maxWidth: 1200, mx: 'auto' }}>
        {children}
      </Box>
    </Box>
  );
}

export default AdminLayout;
